import { useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { RouteService } from '../../services/route/routeService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage routes fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de rutas.
----------------------------------------------------------------------------------------*/

const useRoutes = (initialFilters = {}) => {
    // STATES
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { userCan } = usePrivilege();
    let filters = {
        limit: 500,
        filter_filters: { ...initialFilters }
    };

    const fetchData = async (f?: any) => {
        if (!userCan('list', 'route')) return;
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        setLoading(true);
        try {
            const response = await (new RouteService()).listForSelect(newFilters);
            const fetchedData = response.getResponseData();
            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: any) => ({
                    value: data.id,
                    label: data.name
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching routes:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const getRoutesList = (entity?: string | null, notShowStatusID?: Array<string> | null, notShowStatusName?: Array<string> | null) => {
        let dataCopy = [...data];
        if (entity) return dataCopy.filter((state: any) => state.entity === entity);
        if (notShowStatusID && Array.isArray(notShowStatusID)) dataCopy = dataCopy.filter((state: any) => !notShowStatusID.includes(state.value));
        if (notShowStatusName && Array.isArray(notShowStatusName)) dataCopy = dataCopy.filter((state: any) => !notShowStatusName.includes(state.label));
        return dataCopy;
    };

    return { fetchRoutes: fetchData, getRoutesList, loadingRoutes: loading };
}

export default useRoutes;